import { type Operand, OPERAND_TYPE_LIST, OPERAND_TYPE_FUNCTION } from '@atlaskit/jql-ast';
import { OperandValues } from '../../common/constants.tsx';

export const isListOperand = (operand: Operand) => {
	if (operand.operandType === OPERAND_TYPE_LIST) {
		if (operand.values.length === 1) {
			if (operand.values[0].operandType === OPERAND_TYPE_FUNCTION) {
				return Boolean(OperandValues[operand.values[0].function.value]?.isList);
			}

			return false;
		}
		return true;
	}

	if (operand.operandType === OPERAND_TYPE_FUNCTION) {
		return Boolean(OperandValues[operand.function.value]?.isList);
	}

	return false;
};
